/**
 * 领域热点路由
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("regionalHotSoptsModule", [
    "regionalHotSpotsRouterModule",  //领域热点路由
    "internationalHotSpotsModule", //国际热点
    "nationalHotSpotsModule", //全国热点
    "zhejiangHotSpotsModule", //新疆热点
    "countyHotSpotsModule" //区县热点
]).
controller("regionalHotSpotsCtrl", [function() {

}]);